import { createApi } from '@reduxjs/toolkit/query/react';
import * as API from '../../apiCalls/urls/counsellor';
import { baseQuery } from '../../apiCalls/rtkBaseQuery';



export const webinarApi = createApi({
  baseQuery,
  reducerPath: 'webinarApi',
  tagTypes: ['webinar'],
  endpoints: (builder) => ({
    createWebinar: builder.mutation({
      query: (data) => ({
        url: '/admin/counselor/webinar',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: (result, error, arg) => [{ type: 'webinar', id: arg.id }],
    }),
    deleteWebinar: builder.mutation({
      query: ({ id, data }) => ({
        url: `/admin/counselor/delete-webinar`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: (result, error, arg) => [{ type: 'webinar', id: arg.id }],
    }),
    getAdminWebinarList: builder.query({
      query: ({ page = 1, items = 10, filters }) => ({
        url: `/admin/counselor/webinar/list?page=${page}&items=${items}`,
        method: 'POST',
        body: filters,
      }),
      keepUnusedDataFor: 0,
      providesTags: (result, error, arg) => (result ? [{ type: 'webinar', id: result.id }] : []),
    }),
    getAdminWebinarDetails: builder.query({
      query: (id) => ({
        url: `/admin/counselor/webinar/${id}`,
        method: 'GET',
      }),
      keepUnusedDataFor: 0
    }),
    assignMentorToWebinar: builder.mutation({
      query: (data) => ({
        url: `/admin/counselor/update-webinar`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: (result, error, arg) => [{ type: 'webinar', id: arg.id }],
    }),
    getOrderCounselorOrMentor: builder.query({
      query: (id) => ({
        url: `/admin/counselor/webinar/mentor/${id}`,
        method: 'GET',
      }),
      keepUnusedDataFor: 0,
    }),
  }),
});

export const {
  useCreateWebinarMutation,
  useDeleteWebinarMutation,
  useGetAdminWebinarListQuery,
  useGetAdminWebinarDetailsQuery,
  useAssignMentorToWebinarMutation
} = webinarApi;
